import { UseStorageOptions, UseStorageReturnValue, useLocalStorage as useMantineLocalStorage } from '@mantine/hooks'

export function useLocalStorage<T>(options: UseStorageOptions<T> & { defaultValue: T }): UseStorageReturnValue<T>
export function useLocalStorage<T>(options: UseStorageOptions<T>): UseStorageReturnValue<T | undefined>
export function useLocalStorage<T>(options: UseStorageOptions<T>) {
  return useMantineLocalStorage({
    getInitialValueInEffect: false,
    ...options,
  })
}
